module.exports = __webpack_public_path__ + "static/media/about2.511a060f.jpg";